__turbopack_context__.v({
  "arrow": "AccordionMenuItem-module-scss-module__pUAbMa__arrow",
  "arrowWrapper": "AccordionMenuItem-module-scss-module__pUAbMa__arrowWrapper",
  "body": "AccordionMenuItem-module-scss-module__pUAbMa__body",
  "container": "AccordionMenuItem-module-scss-module__pUAbMa__container",
  "expanded": "AccordionMenuItem-module-scss-module__pUAbMa__expanded",
  "root": "AccordionMenuItem-module-scss-module__pUAbMa__root",
  "summary": "AccordionMenuItem-module-scss-module__pUAbMa__summary",
  "title": "AccordionMenuItem-module-scss-module__pUAbMa__title",
});
